import React, { useEffect, useMemo } from "react";

import useGetAdminConfig from "@/hooks/api/useGetAdminConfig";
import { usePersistState } from "@/hooks/usePersistState";
import { notifyMessage } from "@/utils";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { SupLogo } from "@repo/core-ui";

export default function useAuthWelcome() {
  const { primaryWallet } = useDynamicContext();
  const { data: adminConfig } = useGetAdminConfig();

  const [seenAlert, setSeenAlert] = usePersistState<string>("app-toast-seen", "");
  const alertText = useMemo(() => adminConfig?.rawConfig.toast_text.trim() ?? undefined, [adminConfig?.rawConfig.toast_text]);

  useEffect(() => {
    if (primaryWallet && !!alertText && seenAlert !== `${alertText}`) {
      setTimeout(() => {
        setSeenAlert(`${alertText}`);
        notifyMessage(alertText, undefined, "warning", <SupLogo small />, "notification-alert", 15000);
      }, 100);
    }
  }, [alertText, primaryWallet, seenAlert, setSeenAlert]);
}
